export enum HttpHeader {
  ContentDisposition = 'Content-Disposition',
}
